import { Box, Button, Collapse, Grid } from '@material-ui/core';
import {
  getClassroomIdByUserId,
  getInfosDashboard,
  getInfosIndividual,
  getProfilePreferences,
  getProfilePresentation,
  postStudentAbsence,
  getSchoolById,
  getClassroomInfoById,
  getContractToSign,
  getOpcoRecord,
} from '@webapps/business';
import { useAuth, useQuery, useMutation, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import IncompleteInvisible from 'components/Icons/IncompleteInvisible';
import IncompleteProfil from 'components/Icons/IncompleteProfil';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import Business from './Components/Business';
import Info from './Components/Info';
import ProfilName from './Components/ProfilName';
import School from './Components/School';

import Modal from 'components/Modal';
import DashboardCalendar from './Components/School/DashboardCalendar';
import AbsenceDeclarationModal from 'components/AbsenceDeclarationModal';
import SignupCourse from './Components/SignupCourse';

const DashboardStudent = () => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();
  const { push } = useHistory();
  const { addToast } = useToast();

  const [affiliationsFilter, setAffiliationsFilter] = useState([]);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const [selectedInviteIndex, setSelectedInviteIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [showSignupCourse, setShowSignupCourse] = useState(true);

  const handleOpenAbsenceModal = () => setAbsenceModalOpen(true);
  const handleCloseAbsenceModal = () => setAbsenceModalOpen(false);

  const { data: allInfos = {}, isLoading } = useQuery(getInfosIndividual, {
    key: 'indivudualInfos',
    variables: { id: idUser },
  });

  const { data: dashboardInfo = {}, refetch } = useQuery(getInfosDashboard, {
    key: 'infoDashboardStudent',
    variables: { id: idUser },
  });

  const { data: classroomId } = useQuery(getClassroomIdByUserId, {
    key: 'studentClassroomId',
    variables: { id: idUser },
    enabled: !!idUser
  })

  const { data: { completeRate } = {} } = useQuery(getProfilePresentation, {
    key: 'studentCompleteRate',
    variables: { id: idUser },
  });

  const { data: opcoRecord = {}, refetch: refetchOpcoRecord } = useQuery(getOpcoRecord, {
    key: 'getOpcoRecord',
    variables: { id: idUser, from: 'student' },
  });

  const {
    error,
    isLoading: isLoadingContract,
    isSuccess: isSuccessContract,
    mutateAsync: mutateGetContractToSign,
    data: contract = {},
  } = useMutation(getContractToSign);

  const reload = () => {
    window.location.reload();
  };

  const [open, setOpen] = useState(false);
  const [openPref, setOpenPref] = useState(false);
  // fait a la va vite mais a globaliser sur index et envoyer
  // en props a School

  const handleSetAffiliationsFilter = (value) => {
    setAffiliationsFilter(value);
  };

  const { data: preferences = {} } = useQuery(getProfilePreferences, {
    key: 'preferences',
    variables: { id: idUser },
  });

  useEffect(() => {
    if (preferences.visibleOnCvLibrary === false) {
      setOpenPref(true);
    } else {
      setOpenPref(false);
    }
  }, [preferences]);

  useEffect(() => {
    if (completeRate < 100) {
      setOpen(true);
    } else if (completeRate === 100) {
      setOpen(false);
    }
  }, [completeRate]);

  useEffect(() => {
    if (isSuccessContract) {
      setOpenModal(true);
    } else if (error) {
      addToast({
        status: 'error',
        message: 'Une erreur est survenue',
      });
    }
  }, [isSuccessContract]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'closeModal') {
        setOpenModal(false);
        refetchOpcoRecord();
        addToast({ status: 'success', message: 'Contrat signé avec succès !' });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className={cx(global.container, classes.container)}>
      {showSignupCourse && 1 == 2 && (
        <div className={classes.overlay}>
          <SignupCourse
            onClose={() => setShowSignupCourse(false)}
            onNext={() => setShowSignupCourse(false)}
          />
        </div>
      )}
      <div className={classes.alertContainer} style={open ? { display: ' block' } : { display: 'none' }}>
        <Collapse
          in={open}
          className={classes.collapse}
        >
          <Box className={classes.alertBox}>
            <div
              style={{ display: 'flex' }}
              className={css({ '@media (max-width:600px)': { width: '100%' } })}
            >
              <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <IncompleteProfil className={classes.alertInfo} />
              </div>
              <div style={{ color: '#152652' }}>
                <p className={classes.alertTitle}>
                  Profil incomplet : restrictions
                </p>
                <p className={classes.alertText}>
                  Veuillez cliquer pour en savoir plus
                </p>
              </div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'center' }}
              className={css({ '@media (max-width:600px)': { width: '100%' } })}
            >
              <Button
                aria-label="close"
                onClick={() => {
                  push({
                    pathname: ROUTES_PATH.STUDENT_PROFIL,
                    state: { modal: 'Incomplete' },
                  });
                }}
                size="small"
                className={classes.button}
              >
                Corriger
              </Button>
            </div>
          </Box>
        </Collapse>
        <Collapse
          in={openPref}
          style={openPref ? { display: ' block' } : { display: 'none' }}
          className={classes.collapse}
        >
          <Box className={classes.alertBox}>
            <div
              style={{ display: 'flex' }}
              className={css({ '@media (max-width:600px)': { width: '100%' } })}
            >
              <div
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  display: 'flex',
                }}
              >
                <IncompleteInvisible className={classes.alertInfo} />
              </div>
              <div style={{ color: '#152652' }}>
                <p className={classes.alertTitle}>
                  Invisible par les recruteurs
                </p>
                <p className={classes.alertText}>
                  Veuillez cliquer pour en savoir plus
                </p>
              </div>
            </div>
            <div
              style={{ display: 'flex', justifyContent: 'center' }}
              className={css({ '@media (max-width:600px)': { width: '100%' } })}
            >
              <Button
                aria-label="close"
                onClick={() => {
                  push({
                    pathname: ROUTES_PATH.STUDENT_PROFIL,
                    state: { modal: 'Invisible' },
                  });
                }}
                size="small"
                className={classes.button}
              >
                En savoir plus
              </Button>
            </div>
          </Box>
        </Collapse>
      </div>
      <ProfilName
        city={allInfos?.address?.city}
        cp={allInfos?.address?.cityCode}
        firstName={allInfos?.firstname}
        image={dashboardInfo?.profile?.profileImageUrl}
        isLoading={isLoading}
        lastName={allInfos?.lastname}
        rate={dashboardInfo?.profile?.completeRate}
      />
      {opcoRecord[0]?.contract && !opcoRecord[0]?.contract?.studentSignAction && opcoRecord[0]?.contract?.studentSignAction != "SIGNED" && (
        <Button
          aria-label="close"
          disabled={isLoadingContract}
          onClick={() => mutateGetContractToSign({ id: opcoRecord[0].id, from: 'student' })}
          size="small"
          className={classes.button}
        >
          Signer le contrat
        </Button>
      )}
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item md={3} xs={12} sm={6} className={classes.infoContainer}>
          <Info
            from="formationPostule"
            nombre={dashboardInfo?.candidateCourses}
            title="student.dashboard.formationsCandidatees.title"
            subTitle="student.dashboard.formationsCandidatees.subTitle"
          />
        </Grid>
        <Grid item md={3} xs={12} sm={6} className={classes.infoContainer}>
          <Info
            from="formationSave"
            nombre={dashboardInfo?.savedCourses}
            subTitle="student.dashboard.formationsSauvegardees.subTitle"
            title="student.dashboard.formationsSauvegardees.title"
          />
        </Grid>
        <Grid item md={3} xs={12} sm={6} className={classes.infoContainer}>
          <Info
            from="offrePostule"
            nombre={dashboardInfo?.candidateJobs}
            subTitle="student.dashboard.offresCandidatees.subTitle"
            title="student.dashboard.offresCandidatees.title"
          />
        </Grid>
        <Grid item md={3} xs={12} sm={6} className={classes.infoContainer}>
          <Info
            from="offreSave"
            subTitle="student.dashboard.offresSauvegardees.subTitle"
            nombre={dashboardInfo?.savedJobs}
            title="student.dashboard.offresSauvegardees.title"
          />
        </Grid>

        {affiliationsFilter.length > 0 && allInfos?.classroom?.planning ? (
          // Show 3 columns when affiliationsFilter has items
          <>
            <Grid item md={4} sm={6} xs={12} className={classes.infoContainer}>
              <DashboardCalendar
                classroomId={classroomId?.classroomId}
                onOpenAbsenceModal={handleOpenAbsenceModal}
                display={{
                  declareAbsenceButton: true,
                  seePlanningButton: true,
                  qrCodeButton: true,
                }}
                onClickDate={() => { }}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12} className={classes.infoContainer}>
              <School
                classroomId={classroomId?.classroomId}
                handleSetAffiliationsFilter={handleSetAffiliationsFilter}
              />
            </Grid>
            <Grid item md={4} sm={6} xs={12} className={classes.infoContainer}>
              <Business
                classroomId={classroomId?.classroomId}
                handleSetAffiliationsFilter={handleSetAffiliationsFilter}
              />
            </Grid>
          </>
        ) : (
          // Show 2 columns when affiliationsFilter is empty
          <>
            <Grid item md={6} sm={6} xs={12} className={classes.infoContainer}>
              <School
                classroomId={classroomId?.classroomId}
                handleSetAffiliationsFilter={handleSetAffiliationsFilter}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={12} className={classes.infoContainer}>
              <Business
                classroomId={classroomId?.classroomId}
                handleSetAffiliationsFilter={handleSetAffiliationsFilter}
              />
            </Grid>
          </>
        )}
      </Grid>

      <AbsenceDeclarationModal
        open={absenceModalOpen}
        onClose={handleCloseAbsenceModal}
        student={allInfos}
        classroomId={classroomId?.classroomId}
        onConfirm={handleCloseAbsenceModal}
      />
      <Modal
        withStep={false}
        onCancel={() => setOpenModal(false)}
        open={openModal}
        height="90%"
        width={1000}
        title="Signer votre contrat"
      >
        <iframe src={contract.signature_link} width="100%" height="600px" />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    fontSize: '13.5000px',
    fontWeight: 400,
    color: '#5D75A8',
    lineHeight: '110%',
  },
  overlay: {
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(21, 38, 82, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    padding: spacing(2),
  },
  alertBox: {
    borderLeft: '10px solid #FFA400',
    backgroundColor: '#FFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    width: '60%',
    '@media (max-width:1500px)': { width: '80%' },
    '@media (max-width:1210px)': { width: '90%' },
    '@media (max-width:768px)': { width: '100%' },
  },
  alertBox: {
    backgroundColor: '#FFF',
    border: '3px solid #0060F9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: '10px',
    padding: '10px',
    flexWrap: 'wrap',
  },
  button: {
    padding: '5px 40px',
    marginRight: '15px',
    backgroundColor: '#0060F9',
    color: '#FFF',
    '&:hover': {
      backgroundColor: 'rgb(0, 67, 174)',
    },
    '@media (max-width:1400px)': { padding: '5px 20px' },
    '@media (max-width:600px)': { width: '100%', marginRight: '0' },
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
  },
  alertContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: spacing(1, 5, 1, 0),
    '@media (max-width:1309px)': { flexDirection: 'column' },
    '@media (max-width:768px)': { margin: spacing(1, 0, 1, 0) },
  },
  alertInfo: {
    fontSize: '50px',
    margin: '0 20px',
  },
  alertTitle: {
    marginBottom: spacing(2),
    fontFamily: 'Montserrat',
    fontWeight: 600,
    '@media only screen and (max-width:1920px)': { fontSize: '15.00px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.500px' },
  },
  alertText: {
    marginTop: 0,
    fontFamily: 'Roboto',
    color: '#5D75A8',
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '14px' },
  },
  collapse: {
    width: '49%',
    marginTop: spacing(1),
    marginBottom: spacing(1),
    '@media (max-width:1309px)': { width: '100%' },
  },
  infoContainer: {
    padding: spacing(0, 2.5, 2.5, 0),
    '@media only screen and (max-width:768px)': {
      padding: spacing(0, 0, 2.5, 0),
    },
  },
});

export default DashboardStudent;
